import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { TranslationProvider } from "./i18n";
import reportWebVitals from "./reportWebVitals";
import UserProvider from "./context/UserContext";
import Credentials from "./Credentials";
import { BrowserRouter } from "react-router-dom";
import CookieProvider from "./context/CookieContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <TranslationProvider>
        <CookieProvider>
          <UserProvider>
            <Credentials />
            <App />
          </UserProvider>
        </CookieProvider>
      </TranslationProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
